import classNames from 'classnames';
import React from 'react';
import { SliderInput } from '@meitu/saas-ui';
import { useLocaleStore } from '@/i18n';
import LabelAction from '../label-action';
import './style.less';

type Props = {
    value: number;
    layout?: 'inline' | 'stack';
    onChange: (value: number) => void;
    onAfterChange: (value: number) => void;
    style?: React.CSSProperties;
};

export const OpacitySlider: React.FC<Props> = ({ value, layout = 'inline', onChange, onAfterChange, style }) => {
    const { $t } = useLocaleStore();

    const cls = classNames('opacity-slider', {
        'opacity-slider--stack': layout === 'stack',
    });

    const labelActionStyle = (() => {
        if (layout === 'stack') return {};
        return { height: 34 };
    })();

    const content = (
        <LabelAction
            title={$t((v) => v.textAction.opacity)}
            align
            style={{ ...labelActionStyle, marginTop: 16, ...style }}
        >
            <div className="opacity-slider__controller">
                <SliderInput
                    min={0}
                    max={100}
                    showStepBtn
                    value={value}
                    type="horizontal"
                    onChange={(value) => onChange(value)}
                    onAfterChange={(value) => onAfterChange(value)}
                />
            </div>
        </LabelAction>
    );

    if (layout === 'inline') return content;

    return <div className={cls}>{content}</div>;
};
